export default "__VITE_ASSET__DNT3RB5I__"